import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * Prefixes Inventory / Platform API paths with the deployed API origins.
 * Locally both bases are empty and the Angular proxy handles same-origin paths.
 */
export const apiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith('/')) {
    return next(req);
  }

  const inventoryBase = environment.apiBaseUrl.replace(/\/$/, '');
  if (inventoryBase && (req.url.startsWith('/inventory') || req.url.startsWith('/health'))) {
    return next(req.clone({ url: `${inventoryBase}${req.url}` }));
  }

  const platformBase = environment.platformApiBaseUrl.replace(/\/$/, '');
  if (platformBase && req.url.startsWith('/platform')) {
    return next(req.clone({ url: `${platformBase}${req.url}` }));
  }

  return next(req);
};
